let connect = require("react-redux").connect;
import React from "react";

import StarRatingComponent from "react-star-rating-component";

let actions = require("../actions/actions");

class ModerationStarRating extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            rating: this.props.starRating
        };
    }

    onStarClick(rating) {
        this.props.rateCreator(this.props.creator.id, rating);

        this.setState({
            rating: rating
        });
    }

    render() {
        return (
            <StarRatingComponent
                name="creatorRating"
                starCount={5}
                value={this.state.rating}
                emptyStarColor={"#6D6D6D"}
                starColor={"#000"}
                onStarClick={this.onStarClick.bind(this)}
                editing={this.props.editable}
            />
        );
    }
}

module.exports = connect(null, {
    rateCreator: actions.rateCreator
})(ModerationStarRating);
